<template>
  <div>
    <slot
      v-bind="{ isLoading, isPending, isRunning, success, failure }"
    />
  </div>
</template>

<script lang="ts">
import _ from 'lodash';
import { defineComponent } from 'vue';
import { JobRun } from '@/type';
import { ping } from './job-status-service';

interface Data {
  cancelPing: { (): void }|null;
}

export default defineComponent({
  emits: [
    'changed',
    'failure',
    'pending',
    'running',
    'success',
    'update:modelValue',
  ],
  props: {
    jobId: {
      type: Number,
      required: true,
    },
    modelValue: Object as () => JobRun,
  },
  data(): Data {
    return {
      cancelPing: null,
    };
  },
  computed: {
    isLoading(): boolean {
      return (this.modelValue === undefined);
    },
    status(): string|undefined {
      if (this.modelValue === undefined) return undefined;
      if (this.modelValue === null) return 'PENDING';
      return this.modelValue.status;
    },
    isPending(): boolean {
      return (this.status === 'PENDING');
    },
    isRunning(): boolean {
      return (this.status === 'RUNNING');
    },
    success(): boolean {
      return (this.status === 'SUCCESS');
    },
    failure(): boolean {
      return (this.status === 'FAILURE');
    },
  },
  watch: {
    jobId: {
      handler() {
        if (this.cancelPing) this.cancelPing();
        this.cancelPing = ping(this.jobId, (jobRun) => {
          if (!_.isEqual(this.modelValue, jobRun)) {
            this.$emit('update:modelValue', jobRun);
            this.$emit('changed', jobRun);
          }
        });
      },
      immediate: true,
    },
    status(status: string|undefined) {
      if (status !== undefined) {
        this.$emit(status.toLowerCase(), status);
      }
    },
  },
  beforeUnmount() {
    if (this.cancelPing) {
      this.cancelPing();
    }
  },
});
</script>
